/**
 * @generated SignedSource<<45cb14efc1edaaa557cdf8cf02ef58b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interactivesPlusArchiveQuery$data = {
  readonly plusArchiveInteractivesQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly " $fragmentSpreads": FragmentRefs<"hooksPlusArticleLinkHandlerArticle" | "plusInteractivesContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "interactivesPlusArchiveQuery";
};
export type interactivesPlusArchiveQuery$key = {
  readonly " $data"?: interactivesPlusArchiveQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"interactivesPlusArchiveQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "interactivesPlusArchiveQuery",
  "selections": [
    {
      "alias": "plusArchiveInteractivesQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "scmp_plus_interactives"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "plusInteractivesContentItemContent"
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "hooksPlusArticleLinkHandlerArticle",
                          "selections": [
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckCanShowInPlusPlatformContent",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "__typename",
                                  "storageKey": null
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersCheckArticleIsInSectionsArticle",
                                  "selections": (v2/*: any*/),
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersCheckIsPlusArticle",
                                  "selections": [
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "PaywallType",
                                          "kind": "LinkedField",
                                          "name": "paywallTypes",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "entityUuid",
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "Article",
                                      "abstractKey": null
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersCheckIsStyleArticle",
                                  "selections": (v2/*: any*/),
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersGetArticleTypeArticle",
                                  "selections": [
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "ArticleTypeSegment",
                                          "kind": "LinkedField",
                                          "name": "types",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "ArticleType",
                                              "kind": "LinkedField",
                                              "name": "value",
                                              "plural": true,
                                              "selections": (v1/*: any*/),
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "Article",
                                      "abstractKey": null
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersUseContentSponsorContent",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Topic",
                                      "kind": "LinkedField",
                                      "name": "topics",
                                      "plural": true,
                                      "selections": [
                                        (v0/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Sponsor",
                                          "kind": "LinkedField",
                                          "name": "sponsor",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "args": null,
                                              "kind": "FragmentSpread",
                                              "name": "sponsorTagSponsor"
                                            },
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "name",
                                              "storageKey": null
                                            },
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "type",
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "sponsorType",
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "Article",
                                      "abstractKey": null
                                    },
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "helpersCheckIsMainTopicContent",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Topic",
                                          "kind": "LinkedField",
                                          "name": "topics",
                                          "plural": true,
                                          "selections": (v1/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "args": null,
                                      "argumentDefinitions": []
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "id",
                              "storageKey": null
                            },
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "urlAlias",
                              "storageKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        }
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:3)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"scmp_plus_interactives\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "df9a4c7fd5f46a54ecd0562c7ddc01b0";

export default node;
